import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Button from "../../common/components/Button";
import FileUploader from "../../common/components/FileUploader";
import Textfield from "../../common/components/Textfiled";
import { useRiskMatrixCommond } from "./hooks/useRiskMatrixCommond";

function RegisterRiskMatrix() {
  const { state } = useLocation();
  const {
    riskMatrix,
    handleChangeRiskMatrix,
    errors: { errors },
    createRiskMatrix,
    setDefaultValues,
    updateRiskMatrix,
  } = useRiskMatrixCommond();

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (state?.riskMatrix) {
      updateRiskMatrix({ ...riskMatrix, id: state.riskMatrix.id });
      return;
    }
    createRiskMatrix(riskMatrix);
  };

  useEffect(() => {
    if (state?.riskMatrix) {
      setDefaultValues(state.riskMatrix);
    }
  }, [state?.riskMatrix]);

  return (
    <main className="container p-4">
      <header className="d-flex justify-content-between align-items-center mb-4 px-3 py-2 border-bottom">
        <h1 className="h2 m-0 fw-bold">Matriz de riesgo</h1>
      </header>

      <section className="shadow w-100 d-flex flex-column">
        <div className="d-flex gap-3">
          <div className="w-100">
            <p>
              Formulario de matriz de riesgo. Asegúrate de completar todos los
              campos requeridos.
            </p>
            <form onSubmit={handleSubmit}>
              <FileUploader
                accept=".xlsx"
                onFileChange={(file) =>
                  handleChangeRiskMatrix({ name: "file", value: file })
                }
                error={errors.file}
                value={riskMatrix.file}
              />
              <div className="row row-cols-1 row-cols-md-2">
                <Textfield
                  label="Riesgos identificados al inicio del año"
                  type="number"
                  placeholder="Riesgos identificados al inicio del año"
                  name="initialIdentified"
                  onChange={handleChangeRiskMatrix}
                  value={riskMatrix.initialIdentified}
                  error={errors.initialIdentified}
                />
                <Textfield
                  label="Riesgos identificados al final del año"
                  type="number"
                  placeholder="Riesgos identificados al final del año"
                  name="finalIdentified"
                  onChange={handleChangeRiskMatrix}
                  value={riskMatrix.finalIdentified}
                  error={errors.finalIdentified}
                />
                <Textfield
                  label="Riesgos identificados con valoración alta al inicio del año"
                  type="number"
                  placeholder="Riesgos identificados con valoración alta al inicio del año"
                  name="initialHighValuation"
                  onChange={handleChangeRiskMatrix}
                  value={riskMatrix.initialHighValuation}
                  error={errors.initialHighValuation}
                />
                <Textfield
                  label="Riesgos identificados con valoración alta al final del año"
                  type="number"
                  placeholder="Riesgos identificados con valoración alta al final del año"
                  name="finalHighValuation"
                  onChange={handleChangeRiskMatrix}
                  value={riskMatrix.finalHighValuation}
                  error={errors.finalHighValuation}
                />

                <Textfield
                  label="No conformidades identificadas"
                  type="text"
                  placeholder="No conformidades identificadas"
                  name="identifiedIssues"
                  onChange={handleChangeRiskMatrix}
                  value={riskMatrix.identifiedIssues}
                  error={errors.identifiedIssues}
                />
                <Textfield
                  label="No conformidades resueltas"
                  type="text"
                  placeholder="No conformidades resueltas"
                  name="resolvedIssues"
                  onChange={handleChangeRiskMatrix}
                  value={riskMatrix.resolvedIssues}
                  error={errors.resolvedIssues}
                />
              </div>

              <Button type="submit">Guardar</Button>
            </form>
          </div>
        </div>
      </section>
    </main>
  );
}

export default RegisterRiskMatrix;
